import "./AddComponentDialog.scss";
import Dialog from "../../.././/dialogs/Dialog";
import { useState, useRef } from "react";
import { editWidth } from "../../utils/onDragUtils";
import Input from "../../../forms/Input";

const FIELD = 0
const COLUMN = 1
const ROW = 2

export default function CustomComponentDialog({ setOpen, isOpen, setBuildArea, count, editData, parentSetOpen, rowIndex, columnIndex, fieldToMake }) {
  const formRef = useRef(null);

  const [title, setTitle] = useState(editData ? editData.title : '');

  const handleClose = () => {
    setTitle("");
    setOpen(false);
    if (parentSetOpen)
      parentSetOpen(false)
  }


  const addTitle = () => {
    setBuildArea(prevBuildArea => {
      let newBuildArea = structuredClone(prevBuildArea);
      let field = { ui_type: "customComponent", customComponent: title, field: Date.now().toString() }
      switch (fieldToMake) {
        case FIELD:
          newBuildArea[rowIndex].data[columnIndex].data.push(field);
          break;
        case COLUMN:
          newBuildArea[rowIndex].data = count === 0
            ? [{ type: "column", data: [field] }, ...newBuildArea[rowIndex].data]
            : [...newBuildArea[rowIndex].data, { type: "column", data: [field] }]

          if (newBuildArea[rowIndex].data.length === 3)
            newBuildArea[rowIndex] = editWidth(newBuildArea[rowIndex])
          break;
        case ROW: {
          const row = { type: "row", data: [{ type: "column", data: [field] }] };
          newBuildArea.splice(count, 0, row);
          break;
        }
        default:
          break;
      }
      return newBuildArea;
    });
  };

  const handleSave = (e) => {
    e.preventDefault()

    if (title.trim() === '')
      return;

    addTitle();
    handleClose();
  };

  const handleConfirm = () => formRef.current?.requestSubmit();

  return (
    <Dialog
      title={editData ? "Nastavenia vlastného komponentu" : "Vlastný komponent"}
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      className={"AkcUiDesigner"}
      level={1}
      width={window.innerWidth / 3}
    >
      <form ref={formRef} onSubmit={handleSave}>
        <div className="add-dialog-body">
          <div className="form-group">
            <label htmlFor="customComponent">Vlastný komponent</label>
            <Input
              name="customComponent"
              type="text"
              className={"add-dialog-form-control"}
              id="customComponent"
              placeholder="Zadajte názov komponentu"
              value={title}
              onChange={(_, v) => setTitle(v)}
              required
              minLength={3}
            />
          </div>
        </div>
      </form>
    </Dialog >
  )
}
